import request from '@/utils/request'

// 去除对象中的空value属性
function filterParams (obj) {
    let newObj = {}
    for (let val in obj) {
        if (obj[val] !== '') newObj[val] = obj[val]
    }
    return newObj
}

// A- 配置管理
export function adminConfigGet (val) {
    return request({
        url: `/api/epay/admin/config/get/${val}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export function adminConfigUpdate (val) {
    return request({
        url: `/api/epay/admin/config/update/${val.givenConfig}`,
        method: 'post',
        params: { value: val.value },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

// A- deduct 扣-----------------------------------------------------------------------------------------------------------
// apply
export function adminDeductApply (val) {
    return request({
        url: '/api/epay/admin/deduct/apply',
        method: 'post',
        data: val
    })
}
// page
export function adminDeductPage (val) {
    return request({
        url: '/api/epay/admin/deduct/page',
        method: 'post',
        data: val.data,
        params: val.params
    })
}
// getById
export function adminDeductGet (id) {
    return request({
        url: `/api/epay/admin/deduct/get/${id}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// getById
export function adminDeductHandle (val) {
    return request({
        url: `/api/epay/admin/deduct/handle/${val.action}/${val.orderId}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// export
export function adminVpayDeductExport (val) {
    return request({
        url: '/api/epay/admin/deduct/report',
        method: 'post',
        data: filterParams(val),
        responseType: 'blob'
    })
}

// A- 余额退款管理(线上充值)-----------------------------------------------------------------------------------------------
// page
export function adminVpayRefundPage (vo, params) {
    return request({
        url: '/api/epay/admin/refund/page',
        method: 'post',
        data: filterParams(vo),
        params: params
    })
}
// export
export function adminVpayRefundExport (val) {
    return request({
        url: '/api/epay/admin/refund/report',
        method: 'post',
        data: val,
        responseType: 'blob'
    })
}
// 退款管理-退款申请
export function applyOnline (val) {
    return request({
        url: '/api/epay/admin/vpayRefund/applyOnline',
        method: 'post',
        data: val
    })
}
// 退款管理-退款申请审核
export function handleRefund (val) {
    return request({
        url: `/api/epay/admin/cashout/handle/${val.action}/${val.refundId}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

// AdminAccount- 余额帐号管理----------------------------------------------------------------------------------------------------
// export
export function accountExport (val) {
    return request({
        url: '/api/epay/admin/vpayAccount/report',
        method: 'post',
        data: val,
        responseType: 'blob'
    })
}
// getByStoreId
export function accountGetByStoreId (val) {
    return request({
        url: `/api/epay/admin/account/getByStoreId/${val}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// page
export function getPlatListBySaleman (val) {
    return request({
        url: '/api/epay/admin/vpayAccount/page',
        method: 'post',
        data: val.data,
        params: val.params
    })
}
// setCreditLineByStoreId
export function accountSetCreditLine (val) {
    return request({
        url: `/api/epay/admin/vpayAccount/set/creditLine/${val.storeId}`,
        method: 'get',
        params: { creditLine: val.creditLine },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

// 财务管理-提现
export function applyWithdrawal (val) {
    return request({
        // url: '/api/epay/admin/cashout/apply',
        url: '/api/epay/admin/cashout/add',
        method: 'post',
        data: val
    })
}
// 提现管理-列表
export function getCashoutPage (val) {
    return request({
        url: '/api/epay/admin/cashout/page',
        method: 'post',
        data: val.data,
        params: val.params
    })
}
// 提现管理-审核||已开发票||打款
export function handleCashout (val) {
    return request({
        url: `/api/epay/admin/cashout/handle/${val.action}/${val.refundId}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// 提现管理-导出
export function cashoutExport (val) {
    return request({
        url: '/api/epay/admin/cashout/report',
        method: 'post',
        data: val,
        responseType: 'blob'
    })
}
// AdminAccountWarningLine- 余额告急额度管理---------------------------------------------------------------------------------------------
// get
export function accountWarningLineGet (val) {
    return request({
        url: '/api/epay/admin/account/warningLine',
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// update
export function accountWarningLinePost (val) {
    return request({
        url: '/api/epay/admin/account/warningLine',
        method: 'post',
        params: val,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// countStore
export function warningLineCountStore (val) {
    return request({
        url: '/api/epay/admin/vpayAccount/countStoreWarningLine',
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// AdminBankAccount- 银行帐号管理------------------------------------------------------------------------------------------------------
// add
export function bankAccountAdd (val) {
    return request({
        url: '/api/epay/admin/bankAccount/add',
        // method: 'put',
        method: 'post',
        data: val
    })
}
// del
export function bankAccountDel (val) {
    return request({
        // url: `/api/epay/admin/bankAccount/del/${val}`,
        url: `/api/epay/admin/bankAccount/delete/${val}`,
        method: 'delete',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// getAll/list
export function bankAccountGetAll () {
    return request({
        // url: '/api/epay/admin/bankAccount/getAll',
        // method: 'get',
        url: '/api/epay/admin/bankAccount/list',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// update
export function bankAccountUpdate (val) {
    return request({
        // url: `/api/epay/admin/bankAccount/update/${val.id}`,
        url: `/api/epay/admin/bankAccount/modify/${val.id}`,
        method: 'put',
        data: val.in
    })
}
// AdminCharge- 余额充值管理-----------------------------------------------------------------------------------------------------------
// apply
export function chargeApply (a, val) {
    return request({
        url: '/api/epay/admin/charge/applyOffline',
        method: 'post',
        data: val,
        params: { isChargeOther: a }
    })
}
// edit
export function chargeEdit (val) {
    return request({
        url: `/api/epay/admin/charge/edit/${val.chargeId}`,
        method: 'post',
        data: val.vo
    })
}
// export
export function chargeExport (val) {
    return request({
        url: '/api/epay/admin/charge/report',
        method: 'post',
        data: val,
        responseType: 'blob'
    })
}
// get
export function chargeGet (val) {
    return request({
        url: `/api/epay/admin/charge/get/${val}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// handle
export function chargeHandle (val) {
    return request({
        url: `/api/epay/admin/charge/handle/${val.action}/${val.chargeId}?`,
        method: 'get',
        params: { remark: val.remarks },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// logAudit
export function chargeLogAudit (val) {
    return request({
        // url: `/api/epay/admin/charge/log/audit/${val}`,
        url: `/api/epay/admin/charge/auditLog/${val}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// page
export function chargePage (val) {
    return request({
        url: '/api/epay/admin/charge/page',
        method: 'post',
        data: filterParams(val.data),
        params: val.params,
        headers: {
            globalParamA: 'asd'
        }
    })
}
// AdminChargeStats- 余额充值统计-----------------------------------------------------------------------------------------------------
// check
export function chargeStatsCheck (val) {
    return request({
        url: `/api/epay/admin/ebizChargeStats/check/${val.id}`,
        method: 'post',
        data: val.vo
    })
}
// export
export function chargeStatsExport (val) {
    return request({
        url: '/api/epay/admin/ebizChargeStats/report',
        method: 'post',
        data: val,
        responseType: 'blob'
    })
}
// page
export function chargeStatsPage (val) {
    return request({
        url: '/api/epay/admin/ebizChargeStats/page',
        method: 'post',
        data: val.data,
        params: val.params
    })
}
// A- epay_trade 在线交易|支付--------------------------------------------------------------------------------------------------
// page
export function adminEpayTradePage (val) {
    return request({
        url: '/api/epay/admin/epayTrade/page',
        method: 'post',
        data: filterParams(val.data),
        params: val.params
    })
}

// report
export function epayTradeReport (val) {
    return request({
        // url: '/api/epay/admin/vpayTrade/report',
        url: '/api/epay/admin/epayTrade/report',
        method: 'post',
        data: filterParams(val),
        responseType: 'blob'
    })
}

// AdminOrder- 余额明细------------------------------------------------------------------------------------------------------------
// export
export function orderExport (val) {
    return request({
        url: '/api/epay/admin/vpayTrade/report',
        method: 'post',
        data: val,
        responseType: 'blob'
    })
}
// get
export function vpayOrderGetById (val) {
    return request({
        url: `/api/epay/admin/order/get/${val}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// logAudit
export function orderLogAudit (val) {
    return request({
        url: `/api/epay/admin/order/log/audit/${val}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// page
export function orderPage (val) {
    return request({
        url: '/api/epay/admin/vpayTrade/page',
        method: 'post',
        data: val.data,
        params: val.params
    })
}
// AdminTrade- GW交易明细----------------------------------------------------------------------------------------------------------
// export
export function tradeExport (val) {
    return request({
        url: '/api/epay/admin/epayTrade/report',
        method: 'post',
        data: val,
        responseType: 'blob'
    })
}
// get
export function tradeGet (val) {
    return request({
        url: `/api/epay/admin/trade/get/${val}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// page
export function tradePage (val) {
    return request({
        url: '/api/epay/admin/epayTrade/page',
        method: 'post',
        data: filterParams(val.data),
        params: val.params
    })
}
// ChargeOnline- 线上充值--------------------------------------------------------------------------------------------------------------
// prepay- 线上充值
export function onlinePrepay (val) {
    return request({
        url: '/api/epay/charge/online/prepay',
        method: 'post',
        data: val
    })
}
// Gateway- 支付网关----------------------------------------------------------------------------------------------------------------------
// prepay
export function gatewayPrepay (val) {
    return request({
        url: '/api/epay/gateway/prepay',
        method: 'post',
        data: val
    })
}
// A- 支付统计(首页)----------------------------------------------------------------------------------------------------
// analysisVpay
export function statsAnalysisVpay (val) {
    return request({
        url: '/api/epay/admin/stats/analysisVpay',
        method: 'post',
        data: val
    })
}
// statsOnline
export function statsStatsOnline (val) {
    return request({
        url: '/api/epay/admin/stats/statsOnline',
        method: 'post',
        data: val
    })
}
// todoWork
export function statsWorkTodo (val) {
    return request({
        url: '/api/epay/admin/stats/workTodo',
        method: 'get',
        data: val,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// statsVpayCharge
export function statsVpayCharge (val) {
    return request({
        url: '/api/epay/admin/stats/vpayCharge',
        method: 'post',
        data: val
    })
}
// statsVpayTrade
export function statsVpayTrade (val) {
    return request({
        url: '/api/epay/admin/stats/vpayTrade',
        method: 'post',
        data: val
    })
}
// 平账
export function statsBalancingAccount (val) {
    return request({
        url: '/api/epay/admin/ebizChargeStats/balancingAccount',
        method: 'post',
        data: val
    })
}
// 余额充值收款统计 线下--------------------------------------------------
// export
// export
export function statsExport (val) {
    return request({
        url: '/api/epay/admin/ebizChargeStats/report',
        method: 'post',
        data: val,
        responseType: 'blob'
    })
}
// 免单码记录 线下--------------------------------------------------
// 免单码-列表
export function promoPage (val) {
    return request({
        url: '/api/psm/admin/promo/page',
        method: 'post',
        data: val.promoVO,
        params: { page: val.page, size: val.size, descField: val.descField }
    })
}
export function promoExport (val) {
    return request({
        url: '/api/psm/admin/promo/report',
        method: 'post',
        data: val,
        responseType: 'blob'
    })
}
// 免单码详情
export function getDetailByPromoId (val) {
    return request({
        url: `/api/psm/admin/promo/getDetailById/${val}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// 免单码删除
export function delBatchPromo (val) {
    return request({
        url: '/api/psm/admin/promoCode/delete',
        method: 'post',
        data: val
    })
}
// 电子卡券下载
export function markDownloaded (val) {
    return request({
        url: '/api/psm/admin/promoCode/markDownloaded',
        method: 'post',
        data: val
    })
}
// 退款 线下--------------------------------------------------
// 线下退款
export function addRefund (val) {
    return request({
        url: '/api/epay/admin/refund/add',
        method: 'post',
        data: val
    })
}

// 余额账户
export function getByStoreIds (val) {
    return request({
        url: `/api/epay/admin/vpayAccount/getByStoreId/${val}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// 获取小程序码
export function getDiyQRCode (val) {
    return request({
        url: '/api/crm/open/wx/qrcode/getDiyQRCode',
        method: 'post',
        data: val
    })
}
// 业务销售业绩
export function getAnalysisEpay (val) {
    return request({
        url: '/api/epay/admin/epayTrade/analysisEpay',
        method: 'post',
        data: val
    })
}
// 导出业务销售业绩
export function exportAnalysisEpay (val) {
    return request({
        url: '/api/epay/admin/epayTrade/exportAnalysisEpay',
        method: 'post',
        data: val
    })
}
// 余额充值 线上充值-----------------------------------
// prepay- 在线 充值
export function chargeOnlinePrepay (val) {
    return request({
        url: '/api/epay/admin/charge/applyOnline',
        method: 'post',
        data: val
    })
}
